export const EXTERNAL_ROUTES = {
  visionrContactForm: 'https://visionr.com/contact-us#form',
  employeeDashboard: 'https://employee.visionr-internals.com/',
};

export const EXTERNAL_ROUTES_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const;
